import * as React from 'react';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import { useContext } from 'react';
import { MyContext } from '../../context/MyContext';
import { Container } from 'react-bootstrap';

export default function CircularColor() {
  const { showLoading } = useContext(MyContext);
  if (showLoading) {
    return (
      <Container>
      <div style={{ alignItems: "center", display: "flex", justifyContent: "center", marginTop: "10px", marginBottom: "10px", width: "100vw" }}>
      <Stack alignItems="center" sx={{ color: 'grey.500' }} spacing={2} direction="row">
        <CircularProgress color="success" />
      </Stack>
      </div>
      </Container>);      
  }
  else {
    return (<div></div>);
  }
}